var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenround(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3019",
    "data-name": "Group 3019",
    transform: "translate(-9581 4268)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(9581 -4268)",
    fill: "#5bfd66",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(9583 -4266)",
    fill: "#5bfd66",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(9586 -4263)",
    fill: "#5bfd66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenround);
export default __webpack_public_path__ + "static/media/greenround.ca574644de2895e7f5c7f4c934fa9948.svg";
export { ForwardRef as ReactComponent };